import { createContext, useContext, useState } from "react";
import { ClaimType } from "../types";

interface ClaimFormContextType {
  step: number;
  selectedType: ClaimType | "";
  incidentDateTime: string;
  description: string;
  isSubmitting: boolean;
  setStep: (step: number) => void;
  setSelectedType: (type: ClaimType) => void;
  setIncidentDateTime: (date: string) => void;
  setDescription: (description: string) => void;
  setIsSubmitting: (isSubmitting: boolean) => void;
}

const ClaimFormContext = createContext<ClaimFormContextType | undefined>(undefined);

export const useClaimForm = () => {
  const context = useContext(ClaimFormContext);
  if (!context) {
    throw new Error("useClaimForm must be used within a ClaimFormProvider");
  }
  return context;
};

interface ClaimFormProviderProps {
  children: React.ReactNode;
}

export const ClaimFormProvider = ({ children }: ClaimFormProviderProps) => {
  const [step, setStep] = useState(1);
  const [selectedType, setSelectedType] = useState<ClaimType | "">("");
  const [incidentDateTime, setIncidentDateTime] = useState("");
  const [description, setDescription] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  return (
    <ClaimFormContext.Provider
      value={{
        step,
        selectedType,
        incidentDateTime,
        description,
        isSubmitting,
        setStep,
        setSelectedType,
        setIncidentDateTime,
        setDescription,
        setIsSubmitting,
      }}
    >
      {children}
    </ClaimFormContext.Provider>
  );
};